module.exports = __webpack_public_path__ + "img/icon-temp-sensor.cefa70ba.svg";